// Exports
export default {
	"label": "label_RXPi4",
	"row": "row_hFyM4"
};
